goog.provide('el8.appservice.status');

goog.require('el8.app.shared.userHeadlines');
goog.require('el8.appservice.realtime');
goog.require('el8.appservice.websocket');
goog.require('el8.service.intervals');
goog.require('el8.service.pageunload');
goog.require('el8.service.tz');
goog.require('el8.template.service.status');

/**
 * This file manages a periodic poll every page makes to the server (the corresponding view is StatusView).
 *
 * The polling is responsible for lots of things, including:
 *  1. "realtime" data updates
 *  2. getting banners to display on top of the page (userHeadlines)
 *  3. inactivity logouts
 *  4. determining if the user is still connected to Elation's servers
 *
 * Pages poll at a different rate depending on whether they are in focus or in the background.
 */
el8.appservice.status = (function() {

    var LOGIN_PATH = "/login/";
    var REDIRECT_FIELD_NAME = "next";

    var TIMEOUT_LENGTH       = 1000*20;    // 20 seconds
    var FAST_STATUS_INTERVAL = 1000*60;    // 1 minute
    var SLOW_STATUS_INTERVAL = 1000*60*10; // 10 minutes

    /**
     * This must be set GREATER than FAST_STATUS_INTERVAL so that there's no chance we don't
     * tell the server about activity that happens. It doesn't have to be greater than
     * SLOW_STATUS_INTERVAL because currently when the page becomes active, we switch to
     * FAST_STATUS_INTERVAL frequency polling
     */
    var INACTIVITY_PERIOD    = 1000*60*9; // 9 minutes

    var INTERNET_BACK_STATUS_INTERVAL = 1000*20;
    var FAILED_STATUS_THRESHOLD = 4;       // Lower = "No internet" shows up more easily

    /**
     * Private state variables
     */
    var StaleIntervalId = null; // Interval after which we call relp with server stale
    var InactivityTimeoutId = null;
    var Inactive = false;

    var NoInternetFlag = false;
    var NoInternetElt = null;
    var failedStatusCount = 0;

    var StatusCheckInProgress = false;
    var StatusInterval = 0;

    var IsMainPage = (el8Globals.APP === 'home' || el8Globals.APP === 'chart');
    var WrongTzReported = false;

    return {

        /**
         * Check status - whether not logged in and whether connected to internet
         */
        check: function(initRealtimeChannel) {

            if (StatusCheckInProgress) { return; }

            var that = this;
            // Use core ajax request, not el8_ajax
            var args = {};

            if (el8Globals['PAGE_SESSION_ID']) {
                args['_ps'] = el8Globals['PAGE_SESSION_ID'];
            }
            args['_a'] = Inactive ? "0" : "1";
            args['_f'] = StatusInterval/1000;

            StatusCheckInProgress = true;

            var beforeReq = Date.now();

            $.ajax({
                url: "/status/",
                data: args,
                cache: false,
                success: function(data, textStatus, xhr) {

                    var latency = Math.round((Date.now() - beforeReq) / 2);

                    // Expected response in data.status:
                    //   * 1 means logged in
                    //   * 0 means not logged in

                    StatusCheckInProgress = false;
                    if ((data.status)*1 === 0) {
                        that.forwardToLogin(true);
                    } else if (el8Globals.USER_ID && data.user_id*1 !== el8Globals.USER_ID) {
                        that.forcePageRefresh();
                    } else {
                        that.hideNoInternet();
                    }
                    failedStatusCount = 0; // reset count

                    if (data['messages']) {
                        el8.app.shared.userHeadlines.update(data['messages']);
                    }
                    if (data.channel_id) {
                        el8.appservice.realtime.setChannelId(data.channel_id);
                    }
                    if (IsMainPage && data.practice_time) { // only send TZ alert on main pages
                        if (!WrongTzReported && !el8.service.tz.checkLocalIsPractice(data.practice_time)) {
                            var tzAbbrev = el8.service.tz.now().getTimezoneAbbreviation();
                            if (!tzAbbrev) {
                                el8.appservice.notifier.notify("Note that all times are displayed based on your computer's timezone," +
                                    " not your practice's. Please contact support to address this.");
                            } else {
                                el8.appservice.notifier.notify("Note that all times are displayed based on your practice's timezone ("+tzAbbrev+")");
                            }
                            WrongTzReported = true;
                        }

                        var servertime = el8.service.tz.newTzDateTime(data.practice_time);
                        var clienttime = el8.service.tz.newTzDateTime(Date.now());
                        var offset_in_millis = (servertime + latency) - clienttime;
                        el8Globals['CLOCK_OFFSET_MILLIS'] = offset_in_millis;
                    } else {
                        el8Globals['CLOCK_OFFSET_MILLIS'] = 0;
                    }
                },
                timeout: TIMEOUT_LENGTH,
                error: function(xhr, textStatus, errorThrown) {
                    StatusCheckInProgress = false;
                    failedStatusCount++;
                    if (failedStatusCount >= FAILED_STATUS_THRESHOLD) {
                        if (xhr.status === 0) {
                            // status of 0 is the only that implies we literally couldn't reach Elation
                            that.displayConnectionAlert(true);
                        } else {
                            // let the user know something's wrong, but don't claim it's their Internet
                            that.displayConnectionAlert();
                        }
                    }
                }
            });
        },
        reset: function(isSlow) {
            this.resetStatusTimer(isSlow);
            this.resetInactivityTimer();
        },
        init: function(opts) {

            opts = opts || {};
            el8.service.tz.init(); // we want this to run on all pages
            this.check(true); // check now

            var isSlow = !document.hasFocus();
            this.resetStatusTimer(isSlow, true);
            this.resetInactivityTimer();

            el8.appservice.websocket.startWebsocket()

            var that = this;
            $(window).on('blur', function(e) { that.setAsInactive(); });
            $(window).on('focus', function(e) { that.setAsActive(); });

            // we want this to run on all pages
            el8.service.pageunload.init();
        },

        /**
         * Manage login status timers
         */
        startStatusTimer: function(isSlow, noCheck) {
            StatusInterval = !isSlow ? FAST_STATUS_INTERVAL : SLOW_STATUS_INTERVAL;
            if (!isSlow && (noCheck !== true)) { el8.appservice.status.check(); }
            StaleIntervalId = $.el8_setInterval("el8.appservice.status.check()", StatusInterval);
        },
        stopStatusTimer: function() {
            if (StaleIntervalId) { $.el8_clearInterval(StaleIntervalId); }
        },
        resetStatusTimer: function(isSlow, noCheck) {
            this.stopStatusTimer();
            this.startStatusTimer(isSlow, noCheck);
        },

        /**
         * Watching for activity and inactivity to try to be efficient
         */
        setAsActive: function() {
            if (Inactive) {
                Inactive = false;
                el8.appservice.status.reset(); // can't use "this"
                el8.appservice.status.stopActivityWatch(); // can't use "this"
            }
        },
        setAsInactive: function() {
            if (!Inactive) {
                Inactive = true;
                this.resetStatusTimer(true);
                this.startActivityWatch();
            }
        },
        startActivityWatch: function() {
            $(document).on('click', el8.appservice.status.setAsActive)
                       .on('keydown', el8.appservice.status.setAsActive);
        },
        stopActivityWatch: function() {
            $(document).off('click', el8.appservice.status.setAsActive)
                       .off('keydown', el8.appservice.status.setAsActive);
        },

        /**
         * Manage inactivity timers
         *
         * The principle here is that the page is periodically marked "inactive" and a
         * user action (click or keydown) is then required to mark the page "active" again. So
         * any service watching this "Inactive" flag should be focused on watching for activity
         * rather than inactivity (which is subject to false positives).
         *
         * The page is initialized as Inactive=false, and we set a timer for INACTIVITY_PERIOD
         * period of time until the page is marked "inactive" and a user action is required to
         * make the page become "active" again (startActivityWatch watches for activity).
         *
         * The /status/ calls periodically report to the server the status of the Inactive flag
         */
        startInactivityTimer: function() {
            InactivityTimeoutId = $.el8_setTimeout("el8.appservice.status.setAsInactive()", INACTIVITY_PERIOD);
        },
        stopInactivityTimer: function() {
            if (InactivityTimeoutId) { $.el8_clearTimeout(InactivityTimeoutId); }
        },
        resetInactivityTimer: function() {
            this.stopInactivityTimer();
            this.startInactivityTimer();
        },

        /**
         * Manage dialogs
         */
        displayConnectionAlert: function(internetOut) {
            el8.appservice.notifier.clear();
            if (!NoInternetFlag && !NoInternetElt) {
                NoInternetFlag = true;
                NoInternetElt = $(el8.template.service.status.connectionAlertContainer()).appendTo($('body'));
            }

            if (internetOut) {
                $('.text-section', NoInternetElt).text(el8.template.service.status.noInternetText());
            } else {
                $('.text-section', NoInternetElt).text(el8.template.service.status.serverErrorText());
            }
        },

        hideNoInternet: function() {
            if (NoInternetElt && NoInternetFlag) {
                NoInternetFlag = false;
                NoInternetElt.html(el8.template.service.status.internetRestoredAlert());
                $.el8_setTimeout(function() {
                    NoInternetElt.remove();
                    NoInternetElt = null;
                }, INTERNET_BACK_STATUS_INTERVAL);
            }
        },

        forwardToLogin: function(autologout) {

            // Remove any pageunload handlers that require us to be logged in
            el8.service.pageunload.clearLoginRequired();

            var currLoc = encodeURIComponent(window.location.pathname + window.location.search);
            var to_url = LOGIN_PATH+"?"+REDIRECT_FIELD_NAME+"="+currLoc;
            if (autologout) {
                to_url += '&autologout';
            }
            window.location.href = to_url;
        },

        forcePageRefresh: function() {
            window.location.href = window.location.href;
        }

    };

})();
